export default __webpack_public_path__ + "static/attest_auto-f9304e85ac1c5bc2e528b1a80c842c14.png";